/**
 * THE TAG LIST BEHIND "TOPICS YOU KNOW BEST" (design 24, T25) - `suggestTags` asked once, with
 * nothing typed, which answers other authors' tags as `items` and MoonX's own list as `groups`.
 *
 * WHY IT IS NOT ONE OF `useApplicationData`'s READS. Those are loaded together because they
 * contradict each other if they are not (the application is a join over the profile). The tag list
 * agrees or disagrees with nothing: it only offers words. It is optional the way the category
 * catalogue is - the field still takes a typed topic when it is loading, has failed, or arrives with
 * no `groups` (the server before design 24's pause) - so it loads beside the one field that uses it.
 */
import { useCallback } from 'react';
import type { TagSuggestions } from '../contract';
import { useApplicationApi } from './provider';
import { useAsyncResource } from './useAsyncResource';
import type { AsyncResource } from './useAsyncResource';

export function useTagList(): AsyncResource<TagSuggestions> {
  const api = useApplicationApi();
  return useAsyncResource<TagSuggestions>(
    useCallback((signal) => api.suggestTags(undefined, { signal }), [api]),
  );
}
